import { connect } from 'react-redux';
import orderGroupedItems, { setItemOffset } from '../actions/actionCreators/orderGroupedItems';
import InteractiveDnd from '../components/InteractiveDnd';
import selectGroupedItems from '../selectors/selectGroupedItems';
import selectSolutionShown from '../selectors/selectSolutionShown';
const mapStateToProps = (state, _ref) => {
  let {
    exerciseId,
    initialGroupedItems
  } = _ref;
  return {
    groupedItems: selectGroupedItems(state, exerciseId) || initialGroupedItems,
    solutionShown: selectSolutionShown(state, exerciseId)
  };
};
const mapsDispatchToProps = (dispatch, _ref2) => {
  let {
    exerciseId
  } = _ref2;
  return {
    orderGroupedItems: groupedItems => dispatch(orderGroupedItems(exerciseId, groupedItems)),
    setItemOffset: (itemId, offset) => dispatch(setItemOffset(exerciseId, itemId, offset))
  };
};
export default connect(mapStateToProps, mapsDispatchToProps)(InteractiveDnd);